import request from '@/plugins/ecommerce_axios'

export const GetUFsAPI = async () => {
  const response = await request.get('/utils/list/estados-cidades')
  return response.data
}

export const GetMunicipiosByUFAPI = async (uf) => {
  const response = await request.get(`/utils/get/cidades-by-uf/${uf}`)
  return response.data
}

export const SearchCEPAPI = async (cep) => {
  const response = await request.get(`/utils/get/cep/${cep}`)
  return response.data
}

export const SearchCNPJAPI = async (cnpj) => {
  const response = await request.get(`/utils/get/cnpj/${cnpj}`)
  return response.data
}